<mat-form-field
  appearance="outline"
  class="wideInput"
  [ngClass]="{ 'error-border': customErrorMessage }">

  <mat-label
    [ngClass]="{ 'error-text': customErrorMessage }">
    {{ label }}
  </mat-label>

  <textarea 
    matInput
    cdkTextareaAutosize
    #autosize="cdkTextareaAutosize"
    cdkAutosizeMinRows="15"
    cdkAutosizeMaxRows="50"
    [required]="isRequired"
    errorState="textInputField.hasError('required')"
    [formControl]="textInputField"
    id="{{ name }}"
    (keyup)="handleInputEvent($event)">
  </textarea>

  <mat-error 
    *ngIf="customErrorMessage">
    {{ customErrorMessage }}
  </mat-error>

</mat-form-field>  
